import { render, staticRenderFns } from "./AttachmentSingleModule.vue?vue&type=template&id=73696264&scoped=true"
import script from "./AttachmentSingleModule.vue?vue&type=script&lang=js"
export * from "./AttachmentSingleModule.vue?vue&type=script&lang=js"
import style0 from "./AttachmentSingleModule.vue?vue&type=style&index=0&id=73696264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73696264",
  null
  
)

export default component.exports